module.exports = __webpack_public_path__ + "img/pause-icon.ad7a43d4.svg";